import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './flexContainer.scss'

const FlexContainer = ({
	children,
	className,
	flexDirection,
	justifyContent,
	alignItems,
	withPadding,
	wrap,
	borderBetweenChilds,
	noSpaceBetweenChilds,
	smallSpacing,
}) => {
	const flexContainerClass = 'c-flex-container'
	const cssClasses = classNames(
		flexContainerClass,
		flexDirection && `${flexContainerClass}--direction-${flexDirection}`,
		justifyContent &&
			`${flexContainerClass}--justify-content-${justifyContent}`,
		alignItems && `${flexContainerClass}--align-items-${alignItems}`,
		withPadding && `${flexContainerClass}--with-padding`,
		wrap && `${flexContainerClass}--wrap`,
		noSpaceBetweenChilds &&
			`${flexContainerClass}--no-space-between-childs`,
		smallSpacing && `${flexContainerClass}--small-spacing`,
		className
	)
	const filteredChildren = React.Children.toArray(children)

	return (
		<div className={cssClasses}>
			{React.Children.map(filteredChildren, child => (
				<div
					className={classNames(
						`${flexContainerClass}__item`,
						borderBetweenChilds &&
							`${flexContainerClass}__item--bordered`
					)}
				>
					{child}
				</div>
			))}
		</div>
	)
}

FlexContainer.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	flexDirection: PropTypes.oneOf(['row', 'column']),
	justifyContent: PropTypes.oneOf([
		'flex-start',
		'center',
		'flex-end',
		'space-between',
	]),
	alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
	withPadding: PropTypes.bool,
	wrap: PropTypes.bool,
	borderBetweenChilds: PropTypes.bool,
	noSpaceBetweenChilds: PropTypes.bool,
	smallSpacing: PropTypes.bool,
}

FlexContainer.defaultProps = {
	children: null,
	className: null,
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	withPadding: false,
	wrap: false,
	borderBetweenChilds: false,
	noSpaceBetweenChilds: false,
	smallSpacing: false,
}

export default FlexContainer
